// @ts-nocheck
import { navigate } from '../../lib/routerAdapter';
import styled from 'styled-components';
import { EditOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons';
import Button from 'antd/lib/button';
import notification from 'antd/lib/notification';
import qs from 'query-string';
import React from 'react';
import { Selects } from '../../components';
import { Header, Section } from '../../components/layout';
import { notificationLoading } from '../../components/Notifications';
import Table from '../../components/ui/Table';
import { Popconfirm, Icon, Operations } from './../../components/ui';
import { formatLicensePlateMask } from './../../components/inputs/masked-inputs/LicensePlateInput';
import { applyMaskToValue, formatDateTimeToString, getListInitialState, errorHandler } from './../../lib/helpers';
import { bioTreatmentFacilityFactApi, bioTreatmentFacilityContractApi } from '../../lib/api';
import { accessTypeEnum, bioTreatmentFacilityFactStatus, bioTreatmentFacilityFactStatusEnum } from '../../lib/enum';
import { withUserAccess } from '../withUserAccess';
import Filter from './components/Filter';
import ModalTalonSelect from './components/ModalTalonSelect';
import ModalImage from './components/ModalImage';
const {
  BioTreatmentFacilityFactStatusSelect
} = Selects;
const StyledSpan = styled('span').withConfig({
  displayName: "List__StyledSpan",
  componentId: "sc-1p13rvh-0"
})(["color:#2770ff;font-weight:500;"]);
const StyledStatus = styled('div').withConfig({
  displayName: "List__StyledStatus",
  componentId: "sc-1p13rvh-1"
})(["display:flex;align-items:baseline;"]);
const StyledBtn = styled(Button).withConfig({
  displayName: "List__StyledBtn",
  componentId: "sc-1p13rvh-2"
})(["margin-left:4px;border:none;color:#2770ff;"]);
const INIT_MODAL = {
  show: false,
  fact: null
};
export class BioTreatmentFacilityFacts extends React.Component {
  state = {
    ...getListInitialState(),
    filter: {},
    editStatus: {
      id: null,
      status: null
    },
    columns: [{
      title: 'Гос.номер',
      key: 'licensePlate',
      dataIndex: 'licensePlate',
      render: licensePlate => applyMaskToValue(licensePlate, formatLicensePlateMask)
    }, {
      title: 'Дата посещения',
      key: 'date',
      dataIndex: 'date',
      render: date => formatDateTimeToString(date, 'DD.MM.YYYY HH:mm')
    }, {
      title: 'Статус',
      key: 'status',
      dataIndex: 'status',
      width: 200,
      render: (status, record) => {
        return bioTreatmentFacilityFactStatus[status];
      }
    }, {
      title: 'Объем',
      key: 'volume',
      dataIndex: 'bioTreatmentFacilityTalon.bioTreatmentFacilityVolume.volume'
    }, {
      title: 'Бос',
      key: 'bio',
      dataIndex: 'orgUnitName'
    }, {
      title: 'Номер талона',
      key: 'bioTreatmentFacilityTalonId',
      dataIndex: 'bioTreatmentFacilityTalonId',
      onCell: fact => {
        return {
          onClick: () => {
            this.setState(oldState => ({
              ...oldState,
              modal: {
                show: true,
                fact
              }
            }));
          }
        };
      },
      render: (bioTreatmentFacilityTalonId, fact) => {
        return <StyledSpan>
              {bioTreatmentFacilityTalonId ? bioTreatmentFacilityTalonId : 'Выбрать'}{' '}
            </StyledSpan>;
      }
    }, {
      title: 'Контрагент',
      key: 'companyName',
      dataIndex: 'companyName'
    }, {
      title: 'Снимок',
      key: 'path',
      dataIndex: 'path',
      render: imageUrl => {
        return imageUrl ? <ModalImage files={imageUrl ? [{
          imageUrl,
          title: 'Снимок'
        }] : []} /> : '-';
      }
    }],
    modal: {
      ...INIT_MODAL
    }
  };
  componentDidMount() {
    const {
      page,
      ...filter
    } = qs.parse(window.location.search);
    this.setState({
      filter: {
        ...filter
      },
      page
    }, () => this.fetch(page));
  }
  fetch = async page => {
    const {
      filter
    } = this.state;
    this.setState({
      loading: true
    });
    try {
      notificationLoading({
        message: 'Запрос данных...',
        key: 'savingTalon'
      });
      const data = await bioTreatmentFacilityFactApi.list({
        ...filter,
        page
      });
      this.setState({
        ...data
      });
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    } finally {
      notification.destroy('savingTalon');
      this.setState({
        loading: false,
        page
      });
    }
  };
  applyFilter = filter => {
    const {
      page
    } = this.state;
    this.setState({
      filter
    }, () => this.fetch(page));
  };
  cleanFilter = () => {
    const {
      page
    } = this.state;
    this.setState({
      filter: {}
    }, () => this.fetch(page));
  };
  handleCancelModal = () => {
    this.setState(oldState => ({
      ...oldState,
      modal: {
        ...INIT_MODAL
      }
    }));
  };
  handleSubmitModal = async (fact, bioTreatmentFacilityContractId) => {
    const {
      page
    } = this.state;
    let companyName = null;
    let orgUnitName = null;
    try {
      notificationLoading({
        message: 'Сохраняем...',
        key: 'savingTalon'
      });
      if (bioTreatmentFacilityContractId) {
        const contract = await bioTreatmentFacilityContractApi.get(bioTreatmentFacilityContractId);
        companyName = contract?.company?.name ?? null;
        orgUnitName = contract?.organizationUnit?.name ?? null;
      }
      await bioTreatmentFacilityFactApi.assign({
        ...fact,
        companyName,
        orgUnitName
      });
      await this.fetch(page);
      this.setState(oldState => ({
        ...oldState,
        modal: {
          ...INIT_MODAL
        }
      }));
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    } finally {
      notification.destroy('savingTalon');
    }
  };
  handleCancelTalon = async fact => {
    const {
      page
    } = this.state;
    try {
      notificationLoading({
        message: 'Отменяем талон...',
        key: 'canceledTalon'
      });
      await bioTreatmentFacilityFactApi.changeStatus({
        ...fact,
        status: bioTreatmentFacilityFactStatusEnum.canceled,
        companyName: null,
        orgUnitName: null
      });
      await this.fetch(page);
      this.setState(oldState => ({
        ...oldState,
        modal: {
          ...INIT_MODAL
        }
      }));
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    } finally {
      notification.destroy('canceledTalon');
    }
  };
  render() {
    const {
      location
    } = this.props;
    const {
      data,
      totalCount,
      pageSize,
      page,
      loading,
      filter,
      columns,
      modal
    } = this.state;
    return <>
        <ModalTalonSelect visible={modal.show} onCancelTalon={this.handleCancelTalon} onCancel={this.handleCancelModal} onSubmit={this.handleSubmitModal} bioTreatmentFacilityFact={modal.fact} />
        <Header left={<h1>Журнал въездов</h1>} right={<Button onClick={() => this.fetch(this.state.page)}>
              Обновить данные
            </Button>} />
        <Section>
          <Filter filter={filter} applyFilter={this.applyFilter} cleanFilter={this.cleanFilter} />
          <Table columns={columns} data={data} fetch={this.fetch} fetchOnMount loading={loading} pagination={{
          page,
          pageSize,
          totalCount,
          location
        }} />
        </Section>
      </>;
  }
}
export default withUserAccess(BioTreatmentFacilityFacts);
